<img loading="lazy" alt="" height="1" width="1"
	[src]="environment.ballIconFunction(sport ? sport.code : '', colour)"
>
